"use client";

import React, { useEffect, useRef } from "react";

const BackToTop = () => {
  // Referencia al contenedor del SVG que muestra el progreso del scroll.
  const progressContainerRef = useRef(null);

  useEffect(() => {
    // Obtener el elemento <path> dentro del SVG para manipular su animación.
    const svgPath = progressContainerRef.current?.querySelector("path");
    if (!svgPath) return;

    // Calcular la longitud total del path para configurar la animación.
    const pathLength = svgPath.getTotalLength();
    svgPath.style.transition = "none";
    svgPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
    svgPath.style.strokeDashoffset = pathLength;
    // Forzar reflujo para que los cambios de estilo surtan efecto.
    svgPath.getBoundingClientRect();
    svgPath.style.transition = "stroke-dashoffset 10ms linear";

    // Función que actualiza el progreso del scroll en el path.
    const updateProgress = () => {
      const scroll = window.pageYOffset || document.documentElement.scrollTop;
      const height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      // Se calcula el progreso restando la proporción del scroll a la longitud total.
      const progress = pathLength - (scroll * pathLength) / height;
      svgPath.style.strokeDashoffset = progress;

      const container = progressContainerRef.current;
      if (container) {
        // Mostrar el botón "Back to Top" si se ha hecho scroll mayor a 50 píxeles.
        if (scroll > 50) {
          container.classList.add("rbt-backto-top-active");
        } else {
          container.classList.remove("rbt-backto-top-active");
        }
      }
    };

    // Actualizar el progreso de inmediato y agregar el listener del scroll.
    updateProgress();
    window.addEventListener("scroll", updateProgress);

    // Agregar evento click para hacer scroll hacia el inicio de la página.
    progressContainerRef.current?.addEventListener("click", (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });

    // Limpieza del listener de scroll al desmontar el componente.
    return () => {
      window.removeEventListener("scroll", updateProgress);
    };
  }, []);

  return (
    <div className="rbt-progress-parent" ref={progressContainerRef}>
      <svg
        className="rbt-back-circle svg-inner"
        width="100%"
        height="100%"
        viewBox="-1 -1 102 102"
      >
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
      </svg>
    </div>
  );
};

export default BackToTop;
